import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
export default function DetalhesPublicos({
    open,
    defaultValue,
    onClose,
    onSubmitFiltros,
}: DetalhesPublicosProps) {

    const [selecionados, setSelecionados] = useState<TSelecionados>(defaultValue);

    const dataContent: TDetalhePublico[] = ["Todos", "Apenas fornecedores de leite", "Exceto fornecedores de leite"]

    const handleClick = ((item: string) => {
        setSelecionados(item)
    });

    const handleSubmit = useCallback(() => {
        onSubmitFiltros(selecionados);
        onClose();
    }, [selecionados, onClose, onSubmitFiltros]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'xs'}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Detalhes do público</DialogTitle>
            <DialogContent>
                <Box display={'flex'} flexDirection={'column'}>
                    {
                        (dataContent && dataContent.length > 0) && dataContent.map((i, index) => {
                            const isChecked = selecionados.includes(i);
                            return (
                                <FormControlLabel
                                    key={index}
                                    onChange={() => handleClick(i)}
                                    control={<Radio checked={isChecked} />}
                                    sx={{ mb: 0 }}
                                    label={
                                        <Box>
                                            <Typography>{`${i}`}</Typography>
                                        </Box>
                                    }
                                />
                            );
                        })
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} gap={2}>
                    <Button variant="outlined" onClick={onClose}>
                        Fechar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Selecionar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface DetalhesPublicosProps {
    open: boolean
    defaultValue: "Todos" | "Apenas fornecedores de leite" | "Exceto fornecedores de leite"
    onClose: () => void
    onSubmitFiltros: (value: any) => void
}

type TDetalhePublico = "Todos" | "Apenas fornecedores de leite" | "Exceto fornecedores de leite"
type TSelecionados = string
